// extracted by mini-css-extract-plugin
export var actions = "Hero-module--actions--7e5d6";
export var btn = "Hero-module--btn--29ead";
export var btnOutlinePrimary = "Hero-module--btn-outline-primary--be2b3";
export var btnPrimary = "Hero-module--btn-primary--47c6c";
export var bullets = "Hero-module--bullets--9023d";
export var content = "Hero-module--content--4e8b7";
export var formSelect = "Hero-module--form-select--b3626";
export var hero = "Hero-module--hero--4ecbe";
export var inner = "Hero-module--inner--eeb4e";
export var innerSolo = "Hero-module--innerSolo--4a606";
export var lead = "Hero-module--lead--175bf";
export var media = "Hero-module--media--bd9e3";
export var note = "Hero-module--note--f6ab3";
export var text = "Hero-module--text--c89c4";
export var title = "Hero-module--title--46091";